<div class="section">
  <div class="row">
    <div class="col-12">
      <h3 class="title-with-icon">
        <svg-icon src="assets/images/icons/performance.svg" class="black-medium"></svg-icon>
        <span>{{ "Wireless.KPI.Title" | translate }}</span>
      </h3>
      <ng-container>
        @switch (sensorPresent()) {
          @case (undefined) {
            <loader class="card" [paddingSize]="'small'"></loader>
          }
          @case (true) {
            <ng-container>
              @if (kpis() !== undefined) {
                <kpi-table [vendor]="vendor()" [kpis]="kpis()"></kpi-table>
              } @else {
                <loader class="card" [paddingSize]="'small'"></loader>
              }
            </ng-container>
          }
          @case (false) {
            <div class="card">{{ "Wireless.Sensor.NoSensor" | translate }}</div>
          }
          @default {
            <div class="card">{{ "Wireless.Sensor.UnknownState" | translate }}</div>
          }
        }
      </ng-container>
    </div>
  </div>
</div>
